export class Transaction {
  public validation = false;
  public tran: any = {};
  public error: any = false;
}
